import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
export * from "./types";

export default {
  state: {
    breadcrumbs: [],
  },
  getters,
  actions,
  mutations,
};
